module.exports = __webpack_public_path__ + "static/media/testntel-logo.e756aedb.png";